import './index.scss'

export const Switch = ({...props}) => {
    return(
        <label class="switch-container">
            <input type="checkbox" {...props} checked={props.value}/>
            <span class="switch-slider"></span>
        </label>
    )
}